import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaopostomanutencao(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaopostomanutencao/FIND_POSTOMANUTENCAO':
      case '@operacaopostomanutencao/UPDATE_POSTOMANUTENCAO':
      case '@operacaopostomanutencao/DELETE_POSTOMANUTENCAO':
      case '@operacaopostomanutencao/STORE_POSTOMANUTENCAO':
      case '@operacaopostomanutencao/POSTOMANUTENCAO_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaopostomanutencao/SUCCESS_REMOVE':
      case '@operacaopostomanutencao/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaopostomanutencao/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaopostomanutencao;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaopostomanutencao/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaopostomanutencao;
        break;
      }

      case '@operacaopostomanutencao/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
